import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GenkanService from './pages/GenkanService';
import AiBentoLogo from '@shared/design-system/AiBentoLogo';

// Landing page component (what was previously the full App)
const LandingPage: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [isAuthenticating, setIsAuthenticating] = React.useState(false);

  const handleDoorClick = () => {
    setIsAuthenticating(true);
    setTimeout(() => {
      setIsAuthenticated(true);
      setIsAuthenticating(false);
    }, 1000);
  };

  if (isAuthenticated) {
    return (
      <div style={{
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
          <AiBentoLogo size={200} />
        </div>
        <div style={{
          position: 'absolute',
          bottom: '25%',
          left: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center'
        }}>
          <div style={{ 
            fontSize: '1.1rem', 
            fontWeight: 300, 
            color: '#333', 
            lineHeight: 1.6 
          }}>
            Mimi Network is <span style={{ color: "#8EB700" }}>onchain</span> and coming soon...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)',
      position: 'relative'
    }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <AiBentoLogo size={200} />
      </div>
      <div style={{
        position: 'absolute',
        bottom: '25%',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center'
      }}>
        <div style={{ 
          fontSize: '1.1rem', 
          fontWeight: 300, 
          color: '#333', 
          lineHeight: 1.6 
        }}>
          To enter, please leave your shoes at{' '}
          <button
            onClick={handleDoorClick}
            disabled={isAuthenticating}
            style={{
              background: 'none',
              border: 'none',
              borderBottom: '1px solid #8EB700',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              color: '#8EB700',
              cursor: 'pointer',
              padding: 0,
              margin: 0
            }}
          >
            {isAuthenticating ? 'opening...' : 'the door'}
          </button>
          .
        </div>
      </div>
    </div>
  );
};

// Main App with routing
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/genkan" element={<GenkanService />} />
      </Routes>
    </Router>
  );
}

export default App;
